"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));
var Header_1 = tslib_1.__importDefault(require("../../../view/components/Header"));
var CenteredHeader = styled_components_1["default"](Header_1["default"])(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  text-align: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  text-align: center;\n"])));
exports["default"] = CenteredHeader;
var templateObject_1;
